import React, { useEffect, useState } from 'react';
import { get } from '../lib/api';
export default function PrivateDocumentPhoto({ path, label }) {
  const [src, setSrc] = useState('');
  const [error, setError] = useState('');
  useEffect(() => {
    let cancelled = false;
    let url;
    setSrc(''); setError('');
    get(path, { responseType: 'blob' }).then((blob) => {
      if (cancelled) return;
      url = URL.createObjectURL(blob); setSrc(url);
    }).catch(() => { if (!cancelled) setError('Unable to load document photo.'); });
    return () => { cancelled = true; if (url) URL.revokeObjectURL(url); };
  }, [path]);
  return <figure className="min-w-0 space-y-2">
    <figcaption className="break-words text-sm font-semibold text-gray-900">{label}</figcaption>
    {error ? <p role="alert" className="text-sm text-red-700">{error}</p> : src ? <a href={src} target="_blank" rel="noreferrer" aria-label={'Open ' + label}><img src={src} alt={label} className="h-40 max-w-full rounded border object-contain" /></a> : <p className="text-sm">Loading document...</p>}
  </figure>;
}
